import { CurrentCardService, MyCardService } from '@addins/core/core';
import { CardTool, CardToolsGroup, CardToolsProviderService } from '@addins/core/singlecallcard';
import { Injectable } from '@angular/core';
import { FreetextToolService } from '../freetext-tool/freetext-tool.service';

@Injectable({
  providedIn: 'root'
})
export class JournalToolsControllerService {
  private _addStampToolsGroup: CardToolsGroup;
  get addStampToolsGroup(): CardToolsGroup {
    return this._addStampToolsGroup;
  }

  private _fromMyCallcardOnly: boolean;
  get fromMyCallcardOnly(): boolean {
    return this._fromMyCallcardOnly;
  }

  constructor(
    private cardToolsProvider: CardToolsProviderService,
    private freeTextTool: FreetextToolService,
    private currentCardService: CurrentCardService,
    private myCardService: MyCardService
  ) {}

  setup(canAddFreeTextStampTypes: number[], fromMyCallcardOnly: boolean) {
    if (canAddFreeTextStampTypes.length == 0) {
      return;
    }

    this._fromMyCallcardOnly = fromMyCallcardOnly;
    this._addStampToolsGroup = this.createAddStampToolsGroup(canAddFreeTextStampTypes);

    if (fromMyCallcardOnly) {
      this.currentCardService.$change.subscribe(() => this.onCardChanged());
      this.myCardService.$change.subscribe(() => this.onCardChanged());
    } else {
      this.cardToolsProvider.addCardToolsGroup(this._addStampToolsGroup);
    }
  }

  private createAddStampToolsGroup(canAddFreeTextStampTypes: number[]): CardToolsGroup {
    const addStampToolsGroup: CardToolsGroup = new CardToolsGroup('Mobile.AddStamp', 200);

    canAddFreeTextStampTypes.forEach(freeTextType =>
      addStampToolsGroup.tools.push(
        new CardTool(this.freeTextTool.getFreeTextStampLabel(freeTextType), cardId => this.freeTextTool.addFreeText(cardId, freeTextType))
      )
    );

    return addStampToolsGroup;
  }

  private onCardChanged() {
    const isMyCard: boolean =
      this.myCardService.myCard !== null &&
      this.currentCardService.current !== null &&
      this.currentCardService.current.ObjGuid === this.myCardService.myCardId;

    if (isMyCard) {
      this.cardToolsProvider.addCardToolsGroup(this._addStampToolsGroup);
    } else {
      this.cardToolsProvider.removeCardToolsGroup(this._addStampToolsGroup);
    }
  }
}
